
import PropTypes from 'prop-types';
import { TableRow, TableCell} from "@mui/material";


export default function FindTableRow({
    row, selected, onSelectRow, onClose, onEditRow, onViewRow, formId, onArchive, onComplete, onCancelled, revertInProgress
}){

    const { fullName } = row;

 return (
    <>
    <TableRow hover selected={selected}>

           <TableCell  sx={{whiteSpace: 'nowrap'}} onClick={() => {
            onSelectRow();
            onClose();
           }}>{fullName}</TableCell>

    </TableRow>
</>
 )

}

FindTableRow.propTypes = {
    onEditRow: PropTypes.func,
    onViewRow: PropTypes.func,
    onArchive: PropTypes.func,
    onComplete: PropTypes.func,
    onCancelled: PropTypes.func,
    revertInProgress: PropTypes.func,
  };
  